"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
function propertyDefinition(pvs) {
    return [
        {
            sort_no: 1,
            name: "airinputstemperature",
            group: "",
            quantity: "Temperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 2,
            name: "airinputshumidity",
            group: "",
            quantity: "RelativeHumidity",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: [],
            conversionParameters: {
                pressure: property_1.PropertyValueSet.getAmount("airinputspressure", pvs),
                temperature: property_1.PropertyValueSet.getAmount("airinputstemperature", pvs)
            }
        },
        {
            sort_no: 3,
            name: "airinputspressure",
            group: "",
            quantity: "Pressure",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 3,
            name: "airinputsairflow",
            group: "",
            quantity: "MassFlow",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        }
    ];
}
//# sourceMappingURL=airinputs-definition.js.map